import React from "react"
import { Link } from "gatsby"
import styles from "../css/postcard.module.css"
// import AniLink from "gatsby-plugin-transition-link/AniLink";

export default function PostCard({ post }) {
  const { title, date, slug, spoiler } = post.frontmatter
  // const img = post.frontmatter.image.childImageSharp.fluid;
  const time = Math.ceil(post.timeToRead * 1.75)

  return (
    <article className={styles.card}>
      <div className={styles.info}>
        <div>
          <Link to={`${slug}/`} className={styles.linkTitle}>
            <h2>{title}</h2>
          </Link>
          <h5>
            <span>
              <span role="img" aria-label="coffee-emoji">
                ☕
              </span>{" "}
              {time} min read
            </span>
            &emsp;
            <span>
              <span role="img" aria-label="coffee-emoji">
                📅
              </span>{" "}
              {date}
            </span>
          </h5>
          <p>{spoiler}</p>
        </div>
      </div>
      {/* <div className={styles.image}>
            <Image fluid={img} />
         </div> */}
    </article>
  )
}
